import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '..';

export enum BadgeTotalCount {
  WITHDRAW = 'WITHDRAW',
  DEPOSIT = 'DEPOSIT',
  DOCUMENT = 'DOCUMENT',
  SUPPORT = 'SUPPORT',
  USERNAME = 'USERNAME',
}

interface BadgesSliceState {
  badgeTotalCount: Record<BadgeTotalCount, number>;
}

const initialState: BadgesSliceState = {
  badgeTotalCount: {
    DOCUMENT: 0,
    SUPPORT: 0,
    WITHDRAW: 0,
    DEPOSIT: 0,
    USERNAME: 0,
  },
};

export const badgesSlice = createSlice({
  name: 'badges',
  initialState,
  reducers: {
    setBadgeTotalCount(state: BadgesSliceState, action: PayloadAction<{ badge: BadgeTotalCount; value: number }>) {
      const { badge, value }: { badge: BadgeTotalCount; value: number } = action.payload;

      state.badgeTotalCount[badge] = value;
    },
    clearBadgeTotalCount: () => initialState,
  },
});

// Export the action creators
export const { clearBadgeTotalCount, setBadgeTotalCount } = badgesSlice.actions;

export const getBadges = (state: RootState): BadgesSliceState => state.badges;
